<template>
  <authenticated-layout  :back-route="{
                           name: 'schoolsDashboardWithTenant',
                           params: { tenantId, tab: 'students' }
                         }"
                         :breadcrumbs="breadcrumbItems">

    <user-detail-content
      :user-id="userId"
      :tenant-id="tenantId"
      route-name="tenantUserDetail"
    />
  </authenticated-layout>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import UserDetailContent from "@/components/Users/UserDetailContent.vue";

import {Tenant} from "@YenzaCT/sdk";
import yapi from "@/lib/yapi";
import {useApiCall} from "@/composables/useApiCall";

const route = useRoute();
const { executeApi } = useApiCall();

const userId = computed(() => route.params.userId as string);
const tenantId = route.params.tenantId as string;

const tenant = ref<Tenant>();

const breadcrumbItems = computed(() => [
  {
    text: "My Schools",
    to: { name: "schoolsDashboard" }
  },
  {
    text: tenant.value?.title || "Tenant",
    to: {
      name: "schoolsDashboardWithTenant",
      params: { tenantId: tenant.value?._id, tab: "students" }
    }
  },
  {
    text: "User Details"
  }
]);

async function fetchTenant() {
  const result = await executeApi(async () => {
    const response = await yapi.admin.tenant.get(tenantId);
    return response.data;
  });
  if (result) {
    tenant.value = result;
  }
}

onMounted(async () => {
  await fetchTenant();
});
</script>
